import * as api from '../api';
import { FETCH_NEWS, SET_NEWS, START_LOADING_NEWS, END_LOADING_NEWS } from '../constants/news.js';

// Fetch current news line (public)
export const getNews = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING_NEWS });
    const { data } = await api.getNews();
    dispatch({ type: FETCH_NEWS, payload: data });
    dispatch({ type: END_LOADING_NEWS });
  } catch (error) {
    console.log(error);
    dispatch({ type: END_LOADING_NEWS });
  }
};

// Set or clear news (admin only)
export const setNews = (text) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING_NEWS });
    const { data } = await api.setNews({ text }); // send { text: "..." } or { text: "" }
    dispatch({ type: SET_NEWS, payload: data.data }); // store the text only
    dispatch({ type: END_LOADING_NEWS });
    // alert(data.message);
  } catch (error) {
    console.log(error);
    // alert(error?.response?.data?.message || 'Error updating news');
    dispatch({ type: END_LOADING_NEWS });
  }
};
